import { Loader } from '@Sage/hoi-poi-ui';
import { EmptyScreen } from '@Sage/ssm-web5';
import MarketingCampaigns from 'components/SvgIcons/emptyScreen/MarketingCampaigns';
import { getLiteral } from 'utils/getLiteral';
import useCheckInitialSetup from '../hooks/useCheckInitialSetup';

import './SetupCheckerWrapper.scss';

export default function SetupCheckerWrapper({ children }) {
    const { isLoading, showReadOnlyInitialEmpty } = useCheckInitialSetup();

    if (isLoading) {
        return (
            <div className="setup-checker-wrapper">
                <Loader size="large" />
            </div>
        );
    }

    if (showReadOnlyInitialEmpty) {
        return (
            <div className="setup-checker-wrapper">
                <EmptyScreen
                    title={getLiteral('label_marketing_campaigns_initial_no_content_title')}
                    description={getLiteral('label_marketing_campaigns_no_initial_content_desc')}
                    illustration={<MarketingCampaigns width={144} height={144} />}
                    iconType="image"
                />
            </div>
        );
    }

    return children;
}
